/**
 * DD-3780: masks personal data before a message is sent to the help assistant: Nordic
 * personal identity numbers, e-mail addresses and phone numbers (international, or
 * national with a leading zero). Dates, prices, order and invoice numbers stay. The
 * backend masks again; this keeps the values from even leaving the browser. Same
 * patterns as the backend's patient-data.ts.
 */
const MASK = '[removed]';

const NORDIC_IDENTITY_NUMBER_PATTERNS: RegExp[] = [
    /\b\d{6}[-+A-FU-Y]\d{3}[0-9A-Y]\b/gi,
    /\b(?:\d{2})?\d{6}[-+ ]?\d{4}\b/g,
    /\b\d{11}\b/g,
];

const EMAIL_ADDRESS = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g;
const INTERNATIONAL_PHONE = /\+\d{1,3}(?:[\s-]?\d{1,4}){2,5}\b/g;
const NATIONAL_PHONE = /\b0\d{1,3}(?:[\s-]?\d{2,4}){1,4}\b/g;
const DATE_LIKE = /^\d{2}[-.]\d{2}[-.]\d{2,4}$/;
const MIN_PHONE_DIGITS = 7;

const maskPhoneNumber = (candidate: string): string =>
    candidate.replace(/\D/g, '').length >= MIN_PHONE_DIGITS && !DATE_LIKE.test(candidate) ? MASK : candidate;

/** Identity numbers, e-mail addresses and phone numbers, replaced by "[removed]". */
export const maskPersonalData = (text: string): string =>
    NORDIC_IDENTITY_NUMBER_PATTERNS.reduce((masked, pattern) => masked.replace(pattern, MASK), text)
        .replace(EMAIL_ADDRESS, MASK)
        .replace(INTERNATIONAL_PHONE, maskPhoneNumber)
        .replace(NATIONAL_PHONE, maskPhoneNumber);

/** The name current callers use; it now also masks e-mail addresses and phone numbers. */
export const maskPersonalIdentityNumbers = maskPersonalData;
